import {
  validateFormat,
  validatePresence,
} from 'ember-changeset-validations/validators';

export const BdcChannelAccountValidation = {
  companyName: validatePresence({ presence: true }),
  legalContactName: validatePresence({ presence: true }),
  legalContactEmail: [
    validatePresence({ presence: true }),
    validateFormat({ type: 'email' }),
  ],
};
